module.exports = __webpack_public_path__ + "static/img/khsj.18782352.png";